<div class="nutritional-info-dialog-container">
  <mat-label class="nutritional-info-dialog-header">
    <span>
      <span class="material-symbols-outlined">history</span>
      {{ "nutritionalData" | translate }}
    </span>
    <span class="material-symbols-outlined close-button" [mat-dialog-close]
      >close</span
    >
  </mat-label>
  <hr />
  <div class="nutritional-info-dialog">
    <span class="nutritional-info-details">
      <mat-label class="nutritional-info-header">
        {{ "id" | translate }}:
      </mat-label>
      {{ _data.ingredientIdentifier }}
    </span>
    <span class="nutritional-info-details">
      <mat-label class="nutritional-info-header">
        {{ "ingredientName" | translate }}:
      </mat-label>
      {{ _data.ingredientName }}
    </span>
    <span class="nutritional-info-details">
      <mat-label class="nutritional-info-header">
        {{ "ingredientType" | translate }}:
      </mat-label>
      @if (_data.ingredientType) {
        <span>{{ _data.ingredientType }}</span>
      } @else if (_data.ingredientTypeName) {
        <span>{{ _data.ingredientTypeName }}</span>
      } @else {
        <span>-</span>
      }
    </span>
    @if (
      _data.ingredientTypeIdentifier !== "INT-5" &&
      _data.hasAddPrivileges &&
      this.selectedIndex === 0
    ) {
      <span class="nutritional-info-details">
        <button
          mat-flat-button
          color="primary"
          (click)="addNewRow()"
          [disabled]="isActiveEdit()"
        >
          <span class="material-symbols-outlined">add</span>
          {{ "addNewNutritionalData" | translate }}
        </button>
      </span>
    }
  </div>
  <div class="flex-row flex-additional">
    <mat-tab-group (selectedIndexChange)="onTabChange($event)">
      <mat-tab [label]="'currentData' | translate" />
      <mat-tab [label]="'historyData' | translate" />
    </mat-tab-group>
    <mat-divider class="custom-divider" />
  </div>
  @if (gridRowData().length) {
    <app-table-grid
      [gridRowData]="gridRowData()"
      [gridColumns]="columnDefs()"
      [gridOptions]="gridOptions()"
      [isDialog]="true"
    />
  } @else {
    <div class="image-container">
      <div class="no-data-found">
        <img
          ngSrc="assets/img/nodatafound.svg"
          alt="No Data"
          width="200"
          height="200"
        />
        <div class="no-data-found-text-container">
          {{ "noNutritionalDataFound" | translate }}
        </div>
      </div>
    </div>
  }
</div>
